(ns portal.user-account-page.view.core
  (:require ["@mui/material/Stack$default" :as Stack]
            [common.widgets.page :as page]
            [portal.user-account-page.view.change-password :refer [change-password-form]]
            [portal.user-account-page.view.personal-information :refer [personal-information-form]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui user-account-page []
  (uix/use-effect (fn []
                    (rf/dispatch [:resource.user/get-me])
                    (rf/dispatch [:form.personal-information/init-form])
                    (rf/dispatch [:form.change-password/init])
                    (fn [] (rf/dispatch [:form.personal-information/destroy])))
                  [])
  (let [sso (use-subscribe [:resource.user/sso-enabled])]
    ($ page/page
       ($ page/page-header {:title "My account"})
       ($ page/content-padding
          ($ Stack
             {:spacing 4
              :sx #js {:pb 4}}
             ($ personal-information-form {:sso sso})
             (when-not sso
               ($ change-password-form)))))))
